const NEWS_CATEGORY = [
  { categoryName: "경제", value: "business" },
  { categoryName: "연예", value: "entertainment" },
  { categoryName: "일반", value: "general" },
  { categoryName: "건강", value: "health" },
  { categoryName: "과학", value: "science" },
  { categoryName: "스포츠", value: "sports" },
  { categoryName: "기술", value: "technology" },
];

export default NEWS_CATEGORY;
